import { gql } from '@apollo/client';

export const GET_SLX = gql`
  query querySlx {
    querySlx {
      apt
      streetAddress
      city
      zipCode
      fax
      web
      phone
    }
  }
`;
